
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import CustomSnackbar from '@/components/plugins/CustomSnackbar.vue';
import LoadingOverlay from '@/components/plugins/LoadingOverlay.vue';
import Confirm from '@/components/plugins/Confirm.vue';
import ReasonPrompt from '@/components/plugins/ReasonPrompt.vue';
import SupportChatHeads from '@/components/SupportChatHeads/SupportChatHeads.vue';
import { ACTIONS, GETTERS } from '@/store/namespaces';

@Component({
  components: {
    Confirm,
    ReasonPrompt,
    LoadingOverlay,
    CustomSnackbar,
    SupportChatHeads,
  },
})
export default class App extends Vue {
  oneTimeResetColumnsKey = 'columns_reset';

  oneTimeResetColumnsValue = 'b4Ka2RBI6dy0e11APS4c';

  languageKey = 'language';

  @Getter(GETTERS.USER_ID) userId!: string;

  @Action(ACTIONS.START_DRIVER_CHAT_HUB) startDriverChatHub!: () => Promise<void>;

  @Action(ACTIONS.STOP_DRIVER_CHAT_HUB) stopDriverChatHub!: () => Promise<void>;

  mounted() {
    const columnsReset = localStorage.getItem(this.oneTimeResetColumnsKey);
    if (columnsReset !== this.oneTimeResetColumnsValue) {
      localStorage.removeItem('vehicle_log_sort_by');
      localStorage.setItem(this.oneTimeResetColumnsKey, this.oneTimeResetColumnsValue);
    }

    const language = localStorage.getItem(this.languageKey);
    if (!language) {
      localStorage.setItem(this.languageKey, 'Polish');
    } else {
      switch (language) {
        case 'English': this.$i18n.locale = 'en'; break;
        case 'Ukrainian': this.$i18n.locale = 'ua'; break;
        default: this.$i18n.locale = 'pl'; break;
      }
    }
  }

  @Watch('userId')
  onUserIdChanged(newId: string, oldId: string) {
    if (newId && !oldId) {
      this.startDriverChatHub();
    } else if (!newId && oldId) {
      this.stopDriverChatHub();
    }
  }

  beforeDestroy() {
    this.stopDriverChatHub();
  }
}
